var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClaro(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "2f049668-4cb1-495e-aa7b-e01b7d96bdeb",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1741,
    height: 1741,
    viewBox: "0 0 1741 1741",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "cd8e5ef9-5c1f-4827-a635-ca58e3c8868c",
    "data-name": "Degradado sin nombre 4",
    cx: 1370.17,
    cy: 654.18,
    r: 673.64,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1082)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#ee757b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#e4242d"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "325cc682-9624-44c0-9f63-01f12a477160",
    "data-name": "Degradado sin nombre 2",
    cx: 1358.5,
    cy: 1263.5,
    r: 960.26,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1082)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#9f2024",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9f2024"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a0f24843-bd7e-4659-ad42-05c62a389862",
    "data-name": "Degradado sin nombre 3",
    x1: 1368.59,
    y1: 999.73,
    x2: 1368.59,
    y2: 2045.46,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1082)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#e31b2a",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fce8e2"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Claro") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2229-181.4a864.1,864.1,0,0,0-104.1-412.2l-1.2-2.2-3.6-6.4C1971.4-870,1685.6-1052,1358.6-1052h-6.8C886-1048.2,491.2-661.7,488.1-187.1c0,1.9-.1,3.8-.1,5.7a865.1,865.1,0,0,0,66.7,333.6l1.9,4.6a1.7,1.7,0,0,1,.2.5C689.4,469.2,999.2,689,1358.6,689c7.5,0,14.9-.1,22.3-.3C1850.1,676.7,2229,290.5,2229-181.4Z",
    transform: "translate(-488 1052)",
    style: {
      fill: "url(#cd8e5ef9-5c1f-4827-a635-ca58e3c8868c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2229-181.4a864.1,864.1,0,0,0-104.1-412.2l-1.2-2.2-3.6-6.4C1971.4-870,1685.6-1052,1358.6-1052h-6.8C886-1048.2,491.2-661.7,488.1-187.1c0,1.9-.1,3.8-.1,5.7a865.1,865.1,0,0,0,66.7,333.6l1.9,4.6a1.7,1.7,0,0,1,.2.5C689.4,469.2,999.2,689,1358.6,689c7.5,0,14.9-.1,22.3-.3C1850.1,676.7,2229,290.5,2229-181.4Z",
    transform: "translate(-488 1052)",
    style: {
      fill: "url(#325cc682-9624-44c0-9f63-01f12a477160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M795.1-440.5c0,284.9,250.1,516.7,561,522.8h25c308.4-6,556.9-234,561-515.7h0v-14.2c-4.1-285.5-259.4-515.9-573.5-515.9h0c-316.7,0-573.5,234.2-573.5,523",
    transform: "translate(-488 1052)",
    style: {
      fill: "url(#a0f24843-bd7e-4659-ad42-05c62a389862)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "874f79dc-0f09-47a7-a44d-a433da37719a",
    "data-name": "path3094",
    d: "M803.4-290.9A111.4,111.4,0,0,1,904-227.5h74.1A181.2,181.2,0,0,0,803.4-360.6c-99.9,0-181,81-181,181s81.1,181,181,181A181.2,181.2,0,0,0,978.1-131.7H904A111.4,111.4,0,0,1,803.4-68.3,111.3,111.3,0,0,1,692.1-179.6,111.3,111.3,0,0,1,803.4-290.9Zm1314.1,68.8H1937v67.8h180.3c-.2-3.7.2-67.8.2-67.8Zm-95.7-275.6L1849.5-324.6l47.5,48.2,172.8-173.4ZM1793-349.8l.3-176.3h-67.9l-.2,176.1c3.7-.2,67.8.2,67.8.2Zm-232.8,60.7a118.1,118.1,0,0,0-26.9,7.3c-15,6-36.5,21.4-50.2,39.7v-35.5l-67.2-1V-.5h70.1l-.2-132.3c0-22.3,2.8-38.7,8.3-49.3,10-18.8,34.3-38.5,63.5-38.5l8.6.2,12.8.9-.7-70.6a143.6,143.6,0,0,0-18.2,1ZM1295.5-114c-.5,24.5-7.4,41.3-20.8,50.6a74.1,74.1,0,0,1-43.3,13.8c-10,0-18.4-2.7-25.4-8.2s-10.3-14.7-10.3-27.2,5.7-24.4,16.9-31c6.7-4,17.7-7.3,33.1-10l16.4-3.1a117.8,117.8,0,0,0,19.3-4.9,78.2,78.2,0,0,0,14.1-7.2Zm37.4-159.3q-35.6-18.1-81.5-18.2c-47.1,0-80.2,12.3-99.6,37q-18.1,23.5-20.5,60.2h70.6c1.7-10.7,5.1-19.3,10.2-25.6,7.2-8.6,19.4-12.8,36.7-12.8,15.4,0,27,2.2,34.9,6.6s12.1,12.2,12.1,23.6c-.1,9.4-5.3,16.4-15.7,20.8-5.8,2.6-15.5,4.7-29,6.4l-24.9,3.1c-28.2,3.6-46.5,9.6-61,17.9-26.6,15.5-39.8,40.3-39.8,74.7,0,26.5,8.2,45.3,24.6,59.8S1182.1-.7,1207.4-.7c58.3,0,91-28.5,91-28.5.4,5.3.1,22.8,0,28.5h69.3l.9-203.8q0-50.5-35.7-68.8ZM1014.5-.7h70.2V-362.5h-70.2Zm717.1-67a77,77,0,0,1-77-77,77.1,77.1,0,0,1,77-77.1,77,77,0,0,1,77,77.1A77,77,0,0,1,1731.6-67.7Zm0-223.4a146.3,146.3,0,0,0-146.4,146.4A146.4,146.4,0,0,0,1731.6,1.7,146.4,146.4,0,0,0,1878-144.7a146.3,146.3,0,0,0-146.4-146.4",
    transform: "translate(-488 1052)",
    style: {
      fill: "#fff"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClaro);
export default __webpack_public_path__ + "static/media/claro.1c98d8e43f5fbca8bce071d49f267ef5.svg";
export { ForwardRef as ReactComponent };